// extracted by mini-css-extract-plugin
export var container = "DesktopGallery-module--container--a7Tle";